var FilterableResult = require('./FilterableResult').FilterableResult;
import moment from "moment";
import ViewSwitcher from "../General/ViewSwitcher";
import ReactModal from "react-modal";
import { CreditCardSelector } from "../General/PaymentOption";
import { AbconetApi } from '../General/AbconetApi';
var formatMoney = require('../General/Helper').formatMoney;


import ReactTooltip from 'react-tooltip'

const MAX_ALLOWED_PAYABLE = 50000;



export class InvoiceListing extends React.Component {
    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {
            isCompactView: true,
            resultCollection: props.initialState.resultCollection,
            toPayList: {},
            totalToPay: 0,
            transaction: null,
            modalOpen: false,
            isPaying: false,
            allSelected: false
        };
    }

    setViewSwitcher(data) {
        this.setState({ isCompactView: data.isCompactView });
    }


    checkInvoice(row, ev) {
        var toPayList = this.state.toPayList;

        toPayList[row.invoiceNo] = ev.currentTarget.checked;

        this.setState({ toPayList: toPayList, totalToPay: this.getTotalToPay(toPayList) });
    }

    checkPayAll(ev) {
        var toPayList = {};

        if (ev.currentTarget.checked) {
            var totalAmount = 0;

            for (var i = 0; i < this.state.resultCollection.length; i++) {
                var row = this.state.resultCollection[i];

                if (row.outstandingBalance != row.total) {
                    continue;
                }

                var newTotal = totalAmount + row.total;

                if (newTotal <= MAX_ALLOWED_PAYABLE) {
                    totalAmount = newTotal;
                    toPayList[row.invoiceNo] = true;
                }
            }
        }

        this.setState({ toPayList: toPayList, totalToPay: this.getTotalToPay(toPayList), allSelected: ev.currentTarget.checked });

    }

    handleChange(data) {
        this.setState
        ({
            allSelected: Object.keys(this.state.toPayList).length === data.resultCollection.length,
            resultCollection: data.resultCollection,
            totalToPay: this.getTotalToPay(this.state.toPayList, data.resultCollection)
        });
    }


    getTotalToPay(toPayList, resultCollection) {
        if (resultCollection == null) {
            resultCollection = this.state.resultCollection;
        }

        var outstandingBalance = 0;

        for (var i = 0; i < resultCollection.length; i++) {
            var invoice = resultCollection[i];
            if (toPayList[invoice.invoiceNo] === true && !invoice.paid) {
                outstandingBalance += invoice.outstandingBalance;
            }
        }


        return outstandingBalance;
    }

    renderRows(row) {

        var dueDate = moment(row.dueDate).format("DD/MM/YYYY");
        var invoiceLink = <a href={`/api/report/invoice/${row.invoiceNo}/`} target="_blank">{row.invoiceNo}</a>;
        if (row.type == "Payment") {
            dueDate = "";
            invoiceLink = row.invoiceNo;
        }

        return <div className="row" key={row.transactionNo}>
                    <div className="col-6 d-lg-none">
                       Invoice:
                    </div>
                    <div className="col-6 col-lg-1">
                      {invoiceLink}
                    </div>

                   <div className="col-6 d-lg-none">
                       Invoice Date:
                   </div>
                    <div className="col-6 col-lg-2">
                       {moment(row.date).format("DD/MM/YYYY")}
                     </div>

                   <div className="col-6 d-lg-none">
                       Due Date:
                   </div>
                   <div className="col-6 col-lg-2">
                       {dueDate}
                   </div>

                   <div className="col-6 d-lg-none">
                       PO Number:
                   </div>
                    <div className="col-6 col-lg-2">
                       {row.purchaseNumber}
                    </div>

                   <div className="col-6 d-lg-none">
                       Total inc GST:
                   </div>
                    <div className="col-6 col-lg-2 text-lg-right">
                       {formatMoney(row.total)}
                    </div>

                    <div className="col-6 d-lg-none">
                        Balance remaining:
                    </div>
                    <div className="col-6 col-lg-2 text-lg-right">
                        {this.renderOutstandingBalance(row)}
                       
                    </div>

                   <div className="col-6 d-lg-none">
                       Pay Now
                   </div>
               </div>;
    }

    renderOutstandingBalance(row) {
        if (row.paid) {
            return null;
        }

        return formatMoney(row.outstandingBalance);
        
    }

    renderPayNow() {
        var disabled = false;
        if (this.state.totalToPay <= 0) {
            disabled = true;
        }        
        return <button className="btn btn-primary" disabled={disabled} onClick={this.openModal.bind(this)}>Pay Now</button>;

    }

    renderPayExternal() {
        
        if (this.props.user.abcoUser.paymentUrl == null || this.props.user.abcoUser.paymentUrl == '') {
            return <div></div>;
        }

        return <div>
            <hr />
            <p>
                You will be directed to a secure page where you can pay for your invoices.
            </p>
            <a href={this.props.user.abcoUser.paymentUrl} className="btn btn-primary" target="_blank">
                Pay Now
            </a>
        </div>;
    }

    renderData(resultCollection) {

        var invoiceRow = [];
        var outstandingBalance = 0;
        for (var i = 0; i < resultCollection.length; i++) {
            var row = resultCollection[i];
            invoiceRow.push(this.renderRows(row));
            outstandingBalance += row.outstandingBalance;
        }
        
        return (
            <div><div className="list-group invoice-listing list-group-table">
                <ReactTooltip />
                <div className="container">
                    <div className="row-container header d-none d-lg-block">
                        <div className="row">
                            <div className="col-1">
                                Invoice
                            </div>
                            <div className="col-2">
                                Invoice Date
                            </div>
                            <div className="col-2">
                                Due Date
                            </div>
                            <div className="col-2">
                                PO
                            </div>
                            <div className="col-2 text-right">
                                Total inc GST
                            </div>
                            <div className="col-2 text-right">
                                Balance
                            </div>
                        </div>
                    </div>
                    <div className="row-container">
                        {invoiceRow}
                    </div>
                    <div className="row footer row-container mt-3">
                        <div className="col-9 text-right">
                            Total balance owing
                        </div>
                        <div className="col-2 text-right">
                            {formatMoney(outstandingBalance)}
                        </div>
                        <div className="col-11 text-right mt-3">
                            {this.renderPayExternal()}
                        </div>
                    </div>

                </div>


            </div>

                {outstandingBalance > MAX_ALLOWED_PAYABLE && <div className="alert alert-info" role="alert">
                    Payments are limited to {formatMoney(MAX_ALLOWED_PAYABLE)}
                                                             </div>}
            </div>
        );
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.filterableResult.current.updateData();
        this.setState({
            transaction: null,
            modalOpen: false
        });
    }

    handleCreditCardChange(creditCard) {
        this.setState({
            creditCard: creditCard
        });
    }


    handleCvvChange(event) {
        this.setState({ cvv: event.target.value });
    }

    takePayment() {
        if (this.state.cvv == null || this.state.cvv == "") {
            alert('Please enter cvv');
            return;
        }

        var toPayList = [];
        for (var i = 0; i < this.state.resultCollection.length; i++) {
            var invoice = this.state.resultCollection[i];
            if (this.state.toPayList[invoice.invoiceNo] === true) {
                toPayList.push(invoice.invoiceNo);
            }
        }

        var data = {
            paymentId: this.state.creditCard.id,
            invoiceCollection: toPayList,
            cvv: this.state.cvv
        };

        this.setState({ isPaying: true });

        AbconetApi.post(`/api/transaction/makePayment`, data, null, true).then((responseData) => {
            this.setState({
                errorMessage: null,
                transaction: responseData,
                isPaying: false
            });

        }).catch((error) => {
            this.setState({
                errorMessage: error.message,
                isPaying: false
            });
        });


    }

    renderAlertMessage() {
        if (this.state.errorMessage != null) {
            return <div className={`alert alert-danger`} role="alert">
                       {this.state.errorMessage}
                   </div>;
        }
        return null;
    }

    renderFinalPaymentScreen() {
        if (this.state.creditCard != null) {
            var disabled = false;
            var extraClass = "";
            if (this.state.isPaying) {
                disabled = true;
                extraClass = " saving";
            }

            return <div className="text-right pr-3 mt-3">
                    <div>CCV:<input type="text" value={this.state.cvv} onChange={this.handleCvvChange.bind(this)} className="ccvbox" /></div>

                    <div className="font-weight-bold mr-1">Amount: ${this.state.totalToPay.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>                    

                    <button className={"btn btn-primary" + extraClass} onClick={this.takePayment.bind(this)} disabled={disabled}>Pay now</button>
            </div>;
        }
    }

    renderModalHeader() {
        if (this.state.transaction == null) {
            return <h5 className="m-0">Pay Now</h5>;
        }

        return <h5 className="m-0">Thank you for your payment.</h5>;
    }

    renderModal() {
        if (this.state.transaction == null) {
            return (
                <div>
                    <div className="credit-card-selector-container">
                        <strong>Credit Card</strong>
                        <CreditCardSelector onChange={this.handleCreditCardChange.bind(this)} />
                    </div>
                    {this.renderFinalPaymentScreen()}
                </div>
            );
        }

        return <div>
                <p>Your receipt details.</p>
                <dl className="row">
                       <dt className="col-sm-4">Date:</dt>
                       <dd className="col-sm-8">{this.state.transaction.date}</dd>
                       <dt className="col-sm-4">Transaction:</dt>
                       <dd className="col-sm-8">{this.state.transaction.transactionId}</dd>
                       <dt className="col-sm-4">Amount:</dt>
                       <dd className="col-sm-8">{formatMoney(this.state.transaction.amount)}</dd>
                </dl>
                   <div className="alert alert-info" role="alert">
                       Payments may take approximately 5 minutes to update.
                   </div>
            </div>;

    }

    render() {
        var extraClass = "";
        if (this.state.transaction != null) {
            extraClass += " payment-complete";
        }

            return (
            <div className="invoice-section">

                    <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.closeModal.bind(this)} portalClassName="modal-portal" className={"modal-dialog invoice-dialog" + extraClass} overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            {this.renderModalHeader()}
                        </div>
                        <div className="mt-4">
                            {this.renderAlertMessage()}
                            {this.renderModal()}
                            
                        </div>
                        <button onClick={this.closeModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                       
                       
                    </div>
                </ReactModal>

                <FilterableResult ref={this.filterableResult} {... this.props} renderData={this.renderData.bind(this)} onChange={this.handleChange.bind(this)} showLoader={true} />

            </div>
        );
    }

}